(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["search-results"]) return;
  try {
    
  document.querySelectorAll('.vus__view-toggle').forEach((toggle) => {
    const group = toggle.closest('.vus__group');
    const productGrid = group?.querySelector('.vus__product-grid');
    if (!productGrid) return;

    toggle.querySelectorAll('[data-product-view]').forEach((button) => {
      button.addEventListener('click', () => {
        const showGrid = button.dataset.productView === 'grid';
        productGrid.classList.toggle('is-grid', showGrid);

        toggle.querySelectorAll('[data-product-view]').forEach((viewButton) => {
          const selected = viewButton === button;
          viewButton.classList.toggle('is-active', selected);
          viewButton.setAttribute('aria-pressed', selected ? 'true' : 'false');
        });
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["verdosa-head-to-head"] && !Shopify.designMode) return;
  try {
    
function initVerdosaH2H(){
document.querySelectorAll('.vh').forEach(async root=>{
if(root.dataset.ready)return;root.dataset.ready='true';
const t=Object.fromEntries([...root.querySelectorAll('[data-key]')].map(n=>[n.dataset.key,n.textContent]));
const a=root.querySelector('[data-a]'),b=root.querySelector('[data-b]'),out=root.querySelector('[data-results]'),status=root.querySelector('[data-status]'),profiles=new Map();
const node=(tag,text,cls)=>{const n=document.createElement(tag);if(text!=null)n.textContent=text;if(cls)n.className=cls;return n};
const url=v=>{if(!v)return null;try{const u=new URL(v,location.origin);return /^https?:$/.test(u.protocol)?u.href:null}catch{return null}};
function collect(feed){
feed.querySelectorAll('[data-review]').forEach(n=>{
const p=JSON.parse(n.querySelector('script').textContent),doc=new DOMParser().parseFromString(n.querySelector('textarea').value,'text/html');
p.specs={};
const specLabel=label=>/^(official |published )?weight$/i.test(label)?'Weight':label;
const h=[...doc.querySelectorAll('h2,h3')].find(x=>/specification/i.test(x.textContent));
if(h){let next=h.nextElementSibling;while(next&&!/^H[23]$/.test(next.tagName)){const table=next.matches('table')?next:next.querySelector('table');if(table){table.querySelectorAll('tbody tr').forEach(row=>{const cells=row.querySelectorAll('th,td');if(cells.length>1&&!/price/i.test(cells[0].textContent)){const original=cells[0].textContent.trim(),key=specLabel(original),value=(key!==original?original+': ':'')+cells[1].textContent.trim();p.specs[key]=p.specs[key]?p.specs[key]+'; '+value:value}});break}next=next.nextElementSibling}}
const pl=[...doc.querySelectorAll('a[href]')].find(n=>{try{return new URL(n.getAttribute('href'),location.origin).pathname.startsWith('/products/')}catch{return false}});
p.product=pl?url(pl.getAttribute('href')):null;if(p.handle.endsWith('adidas-adizero-adios-pro-5-review'))p.product=url('https://link.amazon/B0eOiQjde');if(!p.product&&p.handle.endsWith('adidas-adizero-evo-sl-review'))p.product=url('/products/adidas-adizero-evo-sl-men-s-running-shoes');if(!p.product&&p.handle.endsWith('asics-superblast-3-review'))p.product=url('/products/asics-superblast-3-unisex-running-shoes');
if(p.handle.endsWith('adidas-adizero-adios-pro-5-review'))p.image='https://cdn.shopify.com/s/files/1/1006/1358/7318/files/adidas-adizero-adios-pro-5-head-to-head.png?v=1790714652';
if(p.handle.endsWith('nike-alphafly-3-review'))p.image='https://cdn.shopify.com/s/files/1/1006/1358/7318/files/vh-only-nike-alphafly-3-review.png?v=1789322236';if(!p.image)p.image=url(doc.querySelector('img')?.getAttribute('src'));
profiles.set(p.handle,p);
});
}
let feed=root.querySelector('[data-feed]'),next=feed.dataset.next;
collect(feed);
const seen=new Set();let failed=false;
try{while(next&&!seen.has(next)){seen.add(next);const u=new URL(next,location.origin);u.searchParams.set('section_id',root.dataset.section);const res=await fetch(u);if(!res.ok)throw new Error();const doc=new DOMParser().parseFromString(await res.text(),'text/html');feed=doc.querySelector('[data-feed]');if(!feed)throw new Error();collect(feed);next=feed.dataset.next}}catch{failed=true}
const list=[...profiles.values()].sort((x,y)=>x.title.localeCompare(y.title));
if(list.length<2){status.textContent=t.empty;return}
for(const s of [a,b]){s.replaceChildren(...list.map(p=>{const o=node('option',p.title);o.value=p.handle;return o}));s.disabled=false}
const params=new URLSearchParams(location.search);a.value=profiles.has(params.get('shoe1'))?params.get('shoe1'):list[0].handle;b.value=profiles.has(params.get('shoe2'))&&params.get('shoe2')!==a.value?params.get('shoe2'):list.find(p=>p.handle!==a.value).handle;
function link(label,href){const n=node('a',label,'vh-link');n.href=url(href);return n}
function content(p,key){const box=node('div'),value=p[key];if(Array.isArray(value)&&value.length){const ul=node('ul');value.forEach(v=>ul.append(node('li',v)));box.append(ul)}else box.append(node('p',typeof value==='string'&&value?value:t.missing));return box}
function animateAccordion(details,summary){
let animation=null,expanded=false;
summary.addEventListener('click',event=>{
event.preventDefault();
const start=details.getBoundingClientRect().height;
expanded=!expanded;
if(animation){animation.cancel();animation=null}
details.open=true;
details.classList.toggle('vh-is-open',expanded);
summary.setAttribute('aria-expanded',String(expanded));
const end=expanded?details.scrollHeight:summary.getBoundingClientRect().height+2;
if(matchMedia('(prefers-reduced-motion: reduce)').matches){details.open=expanded;return}
animation=details.animate({height:[start+'px',end+'px']},{duration:360,easing:'cubic-bezier(.22,1,.36,1)'});
animation.onfinish=()=>{details.open=expanded;animation=null};
});
}
function render(){
for(const o of a.options)o.disabled=o.value===b.value;for(const o of b.options)o.disabled=o.value===a.value;
const pair=[profiles.get(a.value),profiles.get(b.value)];root.querySelector('[data-swap-home]').append(swap);out.replaceChildren();
const heroes=node('div',null,'vh-matchup');
pair.forEach((p,index)=>{
const c=node('article',null,'vh-shoe');
if(url(p.image)){const img=node('img');img.src=url(p.image);img.alt=p.title;c.append(img)}
c.append(node('h2',p.title));
const verdict=content(p,'quick_verdict');verdict.classList.add('vh-shoe__intro');c.append(verdict);
const links=node('div',null,'vh-shoe__links');links.append(link(t.review,p.url));if(p.handle.endsWith('adidas-adizero-adios-pro-5-review'))links.append(link(t.product,'https://link.amazon/B0eOiQjde'));else if(p.product)links.append(link(t.product,p.product));c.append(links);
heroes.append(c);
if(index===0){const center=node('div',null,'vh-versus');center.append(node('span','VS','vh-versus__badge'),swap);heroes.append(center)}
});out.append(heroes);
const scores=node('section',null,'vh-card');scores.append(node('h2',t.score),node('small',t.method));pair.forEach(p=>{const r=node('div',null,'vh-bar');r.append(node('span',p.title));const v=Number(p.score);if(p.score!=null&&p.score!==''&&Number.isFinite(v)&&v>=0&&v<=10){const m=node('meter');m.min=0;m.max=10;m.value=v;m.setAttribute('aria-label',p.title+' '+t.score);r.append(m,node('strong',v+'/10'))}else r.append(node('span',t.missing));scores.append(r)});out.append(scores);
const keys=[...new Set(pair.flatMap(p=>Object.keys(p.specs)))];if(keys.length){const sec=node('section');sec.append(node('h2',t.specs),node('p',t.spec_note));const table=node('table'),head=node('thead'),hr=node('tr');['',...pair.map(p=>p.title)].forEach(v=>{const th=node('th',v);th.scope='col';hr.append(th)});head.append(hr);table.append(head);const body=node('tbody');keys.forEach(k=>{const r=node('tr'),th=node('th',k);th.scope='row';r.append(th);pair.forEach(p=>r.append(node('td',p.specs[k]||t.missing)));body.append(r)});table.append(body);sec.append(table);out.append(sec)}
for(const key of ['strengths','weaknesses','best_for','not_suitable_for','quick_verdict']){const sec=node('section'),fold=['best_for','not_suitable_for'].includes(key);if(!fold)sec.append(node('h2',t[key]));const grid=node('div',null,'vh-pair vh-detail');pair.forEach(p=>{if(fold){const c=node('details',null,'vh-accordion '+(key==='best_for'?'vh-accordion--choose':'vh-accordion--skip')),summary=node('summary',null,'vh-accordion__summary');summary.append(node('span',key==='best_for'?'✓':'−','vh-accordion__icon'),node('span',(key==='best_for'?'Who should choose ':'Who should skip ')+p.title+'?'),node('span',null,'vh-accordion__chevron'));const body=content(p,key);body.classList.add('vh-accordion__body');c.append(summary,body);animateAccordion(c,summary);grid.append(c)}else{const c=node('article',null,'vh-card '+(key==='weaknesses'?'vh-weak':'vh-good'));c.append(node('h3',p.title),content(p,key));if(key==='quick_verdict')c.append(link(t.review,p.url));grid.append(c)}});sec.append(grid);out.append(sec)}
const u=new URL(location.href);u.searchParams.set('shoe1',a.value);u.searchParams.set('shoe2',b.value);history.replaceState(null,'',u);status.textContent=(failed?t.error+' ':'')+t.updated+': '+pair.map(p=>p.title).join(' / ');
}
a.addEventListener('change',render);b.addEventListener('change',render);const swap=root.querySelector('[data-swap]');swap.disabled=false;swap.addEventListener('click',()=>{const old=a.value;a.value=b.value;b.value=old;render()});render();
});
}
initVerdosaH2H();document.addEventListener('shopify:section:load',initVerdosaH2H);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["verdosa-home-comparisons"] && !Shopify.designMode) return;
  try {
    
function initVerdosaComparisonSwipe(){
document.querySelectorAll('.vd-home-comparisons').forEach(section=>{
if(section.dataset.swipeReady)return;
section.dataset.swipeReady='true';
const track=section.querySelector('.vd-home-comparisons__grid');
const cards=[...track.children];
const inset=()=>parseFloat(getComputedStyle(track).scrollPaddingLeft)||0;
const dots=[...section.querySelectorAll('.vd-comparison-dots button')];
const update=()=>{
let nearest=0, distance=Infinity;
cards.forEach((card,i)=>{const d=Math.abs(card.getBoundingClientRect().left-track.getBoundingClientRect().left-inset());if(d<distance){distance=d;nearest=i;}});
if(track.scrollLeft>=track.scrollWidth-track.clientWidth-2)nearest=cards.length-1;
dots.forEach((dot,i)=>{if(i===nearest)dot.setAttribute('aria-current','true');else dot.removeAttribute('aria-current');});
};
dots.forEach((dot,i)=>dot.addEventListener('click',()=>track.scrollTo({left:track.scrollLeft+cards[i].getBoundingClientRect().left-track.getBoundingClientRect().left-inset(),behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth'})));
track.addEventListener('scroll',update,{passive:true});
});
}
initVerdosaComparisonSwipe();
document.addEventListener('shopify:section:load',initVerdosaComparisonSwipe);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["verdosa-latest-reviews"] && !Shopify.designMode) return;
  try {
    
function initVerdosaReviewCarousels(){
document.querySelectorAll('.vd-latest-reviews').forEach(section=>{
if(section.dataset.carouselReady)return;
section.dataset.carouselReady='true';
const track=section.querySelector('.vd-latest-reviews__grid');
const cards=[...track.children];
const dots=[...section.querySelectorAll('.vd-review-dots button')];
function position(card){return track.scrollLeft+card.getBoundingClientRect().left-track.getBoundingClientRect().left-22}
function update(){
if(!matchMedia('(max-width:749px)').matches)return;
let active=0;
if(track.scrollLeft>0 && track.scrollLeft>=track.scrollWidth-track.clientWidth-2)active=cards.length-1;
else cards.forEach((card,i)=>{if(Math.abs(position(card)-track.scrollLeft)<Math.abs(position(cards[active])-track.scrollLeft))active=i});
dots.forEach((dot,i)=>{if(i===active)dot.setAttribute('aria-current','true');else dot.removeAttribute('aria-current')});
}
dots.forEach((dot,i)=>dot.addEventListener('click',()=>track.scrollTo({left:position(cards[i]),behavior:matchMedia('(prefers-reduced-motion:reduce)').matches?'auto':'smooth'})));
track.addEventListener('scroll',update,{passive:true});
new ResizeObserver(update).observe(track);
update();
});
}
initVerdosaReviewCarousels();
document.addEventListener('shopify:section:load',initVerdosaReviewCarousels);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["verdosa-popular-gear"] && !Shopify.designMode) return;
  try {
    
function initVerdosaGear(){
document.querySelectorAll('.vd-popular-gear').forEach(section=>{
if(section.dataset.carouselReady)return;
section.dataset.carouselReady='true';
const track=section.querySelector('.vd-popular-gear__grid');
const cards=[...track.children];
const dots=[...section.querySelectorAll('.vd-gear-dots button')];
function target(i){return Math.min(track.scrollWidth-track.clientWidth,track.scrollLeft+cards[i].getBoundingClientRect().left-track.getBoundingClientRect().left-22)}
function update(){
if(!matchMedia('(max-width:749px)').matches)return;
let active=0;
dots.forEach((dot,i)=>{if(Math.abs(target(i)-track.scrollLeft)<Math.abs(target(active)-track.scrollLeft))active=i});
dots.forEach((dot,i)=>{if(i===active)dot.setAttribute('aria-current','true');else dot.removeAttribute('aria-current')});
}
dots.forEach((dot,i)=>dot.addEventListener('click',()=>track.scrollTo({left:target(i),behavior:matchMedia('(prefers-reduced-motion:reduce)').matches?'auto':'smooth'})));
let pending=false;
track.addEventListener('scroll',()=>{if(pending)return;pending=true;requestAnimationFrame(()=>{update();pending=false})},{passive:true});
new ResizeObserver(update).observe(track);
update();
});
}
initVerdosaGear();
document.addEventListener('shopify:section:load',initVerdosaGear);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["verdosa-product-recommendations"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', (event) => {
    const imageButton = event.target.closest('[data-verdosa-image-direction]');
    if (imageButton) {
      const card = imageButton.closest('[data-verdosa-card]');
      const images = [...card.querySelectorAll('.verdosa-similar-card__image')];
      let index = Number(card.dataset.activeImage || 0);
      index += imageButton.dataset.verdosaImageDirection === 'next' ? 1 : -1;
      index = (index + images.length) % images.length;
      card.dataset.activeImage = index;
      images.forEach((image, imageIndex) => image.classList.toggle('is-active', imageIndex === index));
      card.querySelectorAll('[data-verdosa-dot]').forEach((dot, dotIndex) => dot.classList.toggle('is-active', dotIndex === index));
      card.querySelector('.verdosa-similar-card__more')?.classList.toggle('is-active', index > 2);
      return;
    }

    const railButton = event.target.closest('[data-verdosa-rail]');
    if (railButton) {
      const track = railButton.closest('.verdosa-similar__carousel').querySelector('[data-verdosa-track]');
      const card = track.querySelector('[data-verdosa-card]');
      const distance = card.getBoundingClientRect().width + 24;
      track.scrollBy({ left: railButton.dataset.verdosaRail === 'next' ? distance : -distance, behavior: 'smooth' });
    }
  });

  } catch(e) { console.error(e); }
})();
})();
